<template>
  <dara-single-content-layout container-size="md">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center mb-3">
        <dara-header>{{ $t('notification-panel') }}</dara-header>
        <dara-small class="color--primary cursor--pointer pt-3">
          <div @click="onMarkingAllAsReaded()">
            {{ $t('mark-all-as-readed') }}
          </div>
        </dara-small>
      </div>
      <dara-notification-list ref="daraNotificationList" :pagination="pagination" :show-pagination="true" />

      <dara-modal-confirm
        v-if="allMarkedAsReaded"
        :content="$t('are-you-sure-you-want-to-mark-all-notifications-as-readed')"
        @close="closeModal()"
        @confirm="markAllNotificationsAsReaded()">
      </dara-modal-confirm>
    </template>
  </dara-single-content-layout>
</template>

<script>

import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';
import DaraNotificationList from '@/modules/notification/components/NotificationList.vue';

export default {
  name: 'DaraNotificationListPage',
  components: {
    DaraNotificationList,
    DaraSingleContentLayout,
  },
  data() {
    return {
      notifications: null,
      pagination: {
        page: 1,
        limit: 5,
      },
      allMarkedAsReaded: false,
    };
  },
  methods: {
    markAllNotificationsAsReaded() {
      this.$refs.daraNotificationList.markAllNotificationsAsReaded();
    },
    onMarkingAllAsReaded() {
      this.allMarkedAsReaded = true;
    },
    closeModal() {
      this.allMarkedAsReaded = false;
    },
  },
};
</script>
